<template>
  <div class="form-group has-float-label">
    <vue-tel-input
      type="tel"
      :value="defaultInput"
      @keypress="isNumber($event)"
      @input="(e) => $emit('input', e)"
      @validate="isValidate"
      :preferredCountries="['IN']"
    ></vue-tel-input>
  </div>
</template>
<script>
/* https://github.com/EducationLink/vue-tel-input more ref here*/
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";

export default {
  name: "input",
  props: ["defaultInput"],
  components: {
    VueTelInput,
  },
  methods: {
    isValidate(result) {
      this.$emit("validate", result);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.vue-tel-input {
  height: 38px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
<style>
ul {
  z-index: 5 !important;
}
</style>
